export default "__VITE_ASSET__tWxdIEy5__"